import styled from '@emotion/styled';
import { css } from '@emotion/react';
import H from '../../typography/Headings';
import COLORS3 from '../../styles/emotion/colors3';
import FONT from '../../styles/emotion/fonts';
import MEDIA_QUERY_V2 from '../../styles/emotion/mediaQueryV2';
import SPACING from '../../styles/emotion/spacing';
import { ButtonV3 } from '../ButtonV3';
import { LinkV2 } from '../LinkV2';

export const SectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid ${COLORS3.BLACK_030};
  max-width: 1920px;
  padding: ${SPACING.LG};

  ${MEDIA_QUERY_V2.MOBILE} {
    padding: ${SPACING.S32} ${SPACING.S24};
  }
`;

export const HedWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;

  a {
    font-size: ${FONT.FONT_SIZE_SMALLER};
  }
`;

export const HeadActions = styled.div`
  display: flex;
  column-gap: ${SPACING.SM};
`;

export const TilesWrapper = styled.div`
  display: flex;
  transition: all 0.2s ease-in-out;
  scroll-behavior: smooth;
  padding: ${SPACING.LG} 0;
  column-gap: ${SPACING.S24};

  ${MEDIA_QUERY_V2.MOBILE} {
    padding: ${SPACING.S24} 0;
    column-gap: ${SPACING.S16};
  }

  ${MEDIA_QUERY_V2.DESKTOP_XL} {
    column-gap: ${SPACING.S32};
  }

  ${MEDIA_QUERY_V2.DESKTOP_MASSIVE} {
    column-gap: ${SPACING.LG};
  }

  &::-webkit-scrollbar {
    height: 8px;
    background: ${COLORS3.BLACK_010};
    border-radius: 20px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 20px;
    background: ${COLORS3.BLACK_030};
  }

  white-space: nowrap;
  flex-wrap: initial;
  overflow-x: auto;
  position: relative;
`;

const ScrollButton = styled.div<{ square?: boolean }>`
  align-self: center;
  position: absolute;
  z-index: 2;
  width: 40px !important;
  height: 40px !important;
  visibility: hidden;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${COLORS3.BLACK_100};
  color: ${COLORS3.WHITE_100};
  border-radius: 50%;

  ${MEDIA_QUERY_V2.MOBILE} {
    pointer-events: none;
  }

  ${(props) =>
    props.square &&
    css`
      ${MEDIA_QUERY_V2.DESKTOP} {
        margin-bottom: 51px;
      }

      ${MEDIA_QUERY_V2.TABLET} {
        margin-bottom: 82px;
      }

      ${MEDIA_QUERY_V2.MOBILE} {
        margin-bottom: 76px;
      }
    `};
`;
export const LeftButton = styled(ScrollButton)<{ square?: boolean }>`
  left: -8px;
`;

export const RightButton = styled(ScrollButton)<{ square?: boolean }>`
  right: -8px;
`;

export const ScrollContainer = styled.div<{ scrollable: boolean }>`
  display: flex;
  position: relative;

  ${MEDIA_QUERY_V2.EXCLUDE_MOBILE} {
    &:hover {
      ${LeftButton}, ${RightButton} {
        visibility: ${(props) => (props.scrollable ? 'visible' : 'hidden')};
      }
    }
  }
`;

export const StyledH3 = styled(H.Title3)`
  ${MEDIA_QUERY_V2.MOBILE} {
    ${FONT.textSizeUltraCompact(FONT.SIZE.REGULAR)};
  }
`;

export const NoWrapButton = styled(ButtonV3)`
  white-space: nowrap;
`;

export const NoWrapLink = styled(LinkV2)`
  white-space: nowrap;
`;

export const hidden = css`
  display: none;
`;
